import { FC } from "react";
import { AddAccountPollingProgress } from "./AddAccountPollingProgress";
import { AddSubAccountRolePollingProgress } from "./AddSubAccountRolePollingProgress";
import { useAppSelector } from "../../../../../../store/hooks";
import { accountSetupDialogTypeSelector } from "../../../../../../store/account-setup/selectors/accountSetupDialogTypeSelector";

export const AccountSetupPollingProgress: FC = () => {
  const dialogType = useAppSelector(accountSetupDialogTypeSelector);

  if (dialogType === "add-sub-account-role") {
    return <AddSubAccountRolePollingProgress />;
  }
  return <AddAccountPollingProgress />;
};
